import { useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import api from "../lib/api";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";

export default function RefLanding() {
  const { code } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    const handle = async () => {
      try {
        const { data } = await api.get(`/referral/lookup?code=${encodeURIComponent(code)}`);
        if (data.valid) {
          sessionStorage.setItem("pending_ref_code", code.toUpperCase());
          sessionStorage.setItem("pending_ref_inviter", data.inviter_name);
          toast.success(`🎁 تمت دعوتك بواسطة ${data.inviter_name}`);
        } else {
          toast.error("كود الإحالة غير صحيح");
        }
      } catch { /* ignore */ }
      // If already logged in → dashboard; else → register
      const token = localStorage.getItem("token");
      navigate(token ? "/dashboard" : "/register", { replace: true });
    };
    handle();
  }, [code, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center">
      <div className="text-center">
        <Loader2 className="w-10 h-10 text-[#00E5FF] animate-spin mx-auto" />
        <p className="mt-3 text-[#8FA3BD]">جارٍ التحقق من كود الإحالة...</p>
      </div>
    </div>
  );
}
